import { render, staticRenderFns } from "./temporalOTs.vue?vue&type=template&id=f16b605a"
import script from "./temporalOTs.vue?vue&type=script&lang=js"
export * from "./temporalOTs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports